import React, { useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ChantPopConfirm from "../../../../CommonComponents/ChantTooltip/ChantPopConfirm";
import { json2csv } from "json-2-csv";
import dayjs from "dayjs";
import Rewards from "./Rewards";
import Events from "./Events/Events";
import TabNav from "../../../../CommonComponents/TabNav/TabNav";
import ScreenHeader from "../../../../CommonComponents/ScreenHeader";
import ChantButton from "../../../../CommonComponents/ChantButton/ChantButton";
import {
  EVENTS_ALL_REPORT,
  MEMBER_BY_EVENT_REPORT,
  MEMBER_DETAILS_REPORT,
} from "../../../../constants/leaderboard";

const Leaderboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [showPointsModal, setShowPointsModal] = useState(false);
  const [currentData, setCurrentData] = useState(null);

  const handleDataChange = useCallback((data) => {
    setCurrentData(data);
  }, []);

  const handleDownloadCsv = useCallback(() => {
    if (!currentData) return;

    const { reportType, tableData, dateRange } = currentData;
    let result = [];

    if (reportType === MEMBER_BY_EVENT_REPORT) {
      result = tableData.map((record) => ({
        "Member (All Events)": record?.memberName || "",
        Total: record?.totalPoints || 0,
        Attending: record?.attendingPoints || 0,
        Volunteering: record?.volunteeringPoints || 0,
      }));
    } else if (reportType === MEMBER_DETAILS_REPORT) {
      result = tableData.map((record) => {
        return {
          "Member (All Events)": record?.memberName || "",
          Total: record?.totalPoints || 0,
          Attending: record?.attendingPoints || 0,
          Volunteering: record?.volunteeringPoints || 0,
        };
      });
    } else if (reportType === EVENTS_ALL_REPORT) {
      result = tableData.map((record) => ({
        Events: record?.eventName || "N/A",
        Date: dayjs.unix(record?.eventStartTime).format("DD-MM-YYYY") || "",
        Attendees: record?.attendeesCount || 0,
        Total: record?.totalPoints || 0,
        Attending: record?.attendingPoints || 0,
        Volunteering: record?.volunteeringPoints || 0,
      }));
    } else {
      return;
    }

    const csv = json2csv(result);

    const a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(new Blob([csv], { type: "text/csv" }));

    if (dateRange && dateRange[0] && dateRange[1]) {
      a.download = `Leaderboard_${dayjs(dateRange[0]).format("DD-MM-YYYY")}_${dayjs(dateRange[1]).format("DD-MM-YYYY")}.csv`;
    } else {
      a.download = "Leaderboard.csv";
    }

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }, [currentData]);

  const getCurrentTab = () => {
    if (location.pathname.includes("/rewards")) {
      return "rewards";
    }
    return "points";
  };

  const menuItems = [
    {
      key: "points",
      label: "Points",
    },
    {
      key: "rewards",
      label: "Rewards",
    },
  ];

  const handleTabChange = (tabKey) => {
    switch (tabKey) {
      case "points":
        navigate("/admin/members/leaderboard");
        break;
      case "rewards":
        navigate("/admin/members/leaderboard/rewards");
        break;
      default:
        navigate("/admin/members/leaderboard");
    }
  };

  const renderContent = () => {
    if (location.pathname.includes("/rewards")) {
      return <Rewards />;
    }
    return (
      <Events
        showPointsModal={showPointsModal}
        setShowPointsModal={setShowPointsModal}
        onDataChange={handleDataChange}
      />
    );
  };

  return (
    <div className="leaderboard-container" style={{ padding: "12px" }}>
      <ScreenHeader
        title="Leaderboard"
        actions={
          getCurrentTab() === "points" && (
            <div style={{ display: "flex", gap: "12px" }}>
              <ChantPopConfirm
                title={
                  <p>
                    Download leaderboard data?
                    <br />
                    <span
                      style={{
                        fontSize: "12px",
                        color: "var(--primary-grey-text)",
                      }}
                    >
                      Select a single event to download a full list of
                      attendees.
                    </span>
                  </p>
                }
                onConfirm={handleDownloadCsv}
                onCancel={() => {}}
                okText="Yes"
                cancelText="No"
                trigger="click"
                disabled={!currentData}
              >
                <ChantButton disabled={!currentData}>Download</ChantButton>
              </ChantPopConfirm>
              <ChantButton
                type="secondary"
                onClick={() => setShowPointsModal(true)}
              >
                Manage Points
              </ChantButton>
            </div>
          )
        }
      />

      <div style={{ paddingTop: "2px" }}>
        <TabNav
          items={menuItems}
          activeKey={getCurrentTab()}
          handleTabChange={handleTabChange}
        />
      </div>
      <div className="leaderboard-content">{renderContent()}</div>
    </div>
  );
};

export default Leaderboard;
